import request from '@/router/axios'
import env from '@/config/env'

/**
 * 乘客黑名单分页接口
 * @param data
 */
export const userBlackPage = (data) => {
    return request({
        url: env.ferryUrl+'/userBlack/page',
        method: 'POST',
        data: data
    })
}

/**
 * 乘客黑名单修改状态
 * @param data
 */
export const userBlackChangeStatus = (data) => {
    return request({
        url: env.ferryUrl+'/userBlack/changeStatus',
        method: 'POST',
        data: data
    })
}
/**
 * 乘客黑名单保存
 * @param data
 */
export const saveOrUpdate = (data) => {
    return request({
        url: env.ferryUrl+'/userBlack/saveOrUpdate',
        method: 'POST',
        data: data
    })
}
/**
 * 乘客黑名单修改状态
 * @param data
 */
export const changeStatus = (data) => {
    return request({
        url: env.ferryUrl+'/userBlack/changeStatus',
        method: 'POST',
        data: data
    })
}
